import { render, staticRenderFns } from "./EditUserTelPopup.vue?vue&type=template&id=5b82c438&scoped=true&"
import script from "./EditUserTelPopup.vue?vue&type=script&lang=js&"
export * from "./EditUserTelPopup.vue?vue&type=script&lang=js&"
import style0 from "./EditUserTelPopup.vue?vue&type=style&index=0&id=5b82c438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82c438",
  null
  
)

export default component.exports